module.exports = __webpack_public_path__ + "img/13_mark_n.2a555195.png";